<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Matt Swezey</title>
    <meta name="description" content="Matt Swezey writes software in Austin." />
    <meta name="author" content="Matt Swezey" />
    <meta name="theme-color" content="#07080a" />
    <meta name="color-scheme" content="dark" />
    <script>
      try {
        if (localStorage.getItem('swezey-theme') === 'light') {
          document.documentElement.dataset.theme = 'light';
          document.documentElement.style.colorScheme = 'light';
          document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#e7f0f4');
          document.querySelector('meta[name="color-scheme"]')?.setAttribute('content', 'light');
        }
      } catch {}
    </script>
    <link rel="canonical" href="https://swezey.io/" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="manifest" href="/site.webmanifest" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://swezey.io/" />
    <meta property="og:site_name" content="swezey.io" />
    <meta property="og:title" content="Matt Swezey" />
    <meta property="og:description" content="Matt Swezey writes software in Austin." />
    <meta property="og:locale" content="en_US" />
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content="Matt Swezey" />
    <meta name="twitter:description" content="Matt Swezey writes software in Austin." />
    <!--app-head-->
  </head>
  <body>
    <div id="root"><!--app-html--></div>
    <script type="module" src="/src/entry-client.tsx"></script>
  </body>
</html>
